export const nemiPayTranslation = {
  nemiPay: {
    menu: {
      company: {
        plural: {
          formal: 'Empresas',
          informal: 'empresas',
        },
        singular: {
          formal: 'Empresa',
          informal: 'empresa',
        },
      },
      commerce: {
        plural: {
          formal: 'Comercios',
          informal: 'comercios',
        },
        singular: {
          formal: 'Comercio',
          informal: 'comercio',
        },
      },
      transactions: {
        plural: {
          formal: 'Transacciones',
          informal: 'transacciones',
        },
        singular: {
          formal: 'Transacción',
          informal: 'transacción',
        },
        payins: {
          plural: {
            formal: 'Reporte de Pagos',
            informal: 'pagos',
          },
          filters: {
            title: 'Filtros',
            date: 'Fecha',
            datePlaceholder: 'Selecciona una fecha',
            clear: 'Limpiar',
            search: 'Buscar',
            status: 'Estado',
          },
        },
        statistics: {
          plural: {
            formal: 'Estadísticas',
            informal: 'estadísticas',
          },
          singular: {
            formal: 'Estadística',
            informal: 'estadística',
          },
          filters: {
            title: 'Filtros',
            date: 'Fecha',
            datePlaceholder: 'Selecciona una fecha',
            clear: 'Limpiar',
            search: 'Buscar',
          },
          headers: {
            payins: 'Pagos',
            payouts: 'Payouts',
          },
          cardHeaders: {
            totalPayments: 'Pagos totales',
            completedPayments: 'Completados',
            totalAmount: 'Total Completados',
            averagePayments: 'Promedio',
            yearly: 'Anual completadas',
            monthly: 'Mensual completadas',
            daily: 'Diarias completadas',
            transactionsCount: 'Número de transacciones',
            dailyTransactions: 'Transacciones por día',
            pending: 'Pendientes',
            completed: 'Completados',
            refunded: 'Reembolsados',
            cancelled: 'Cancelados',
            expired: 'Expirados',
            failed: 'Erróneos',
            created: 'Creados',
            awaitingFunds: 'Esperando fondos',
          },
        },
      },
      commerceKind: {
        plural: {
          formal: 'Tipos de comercios',
          informal: 'tipos de comercios',
        },
        singular: {
          formal: 'Tipo de comercio',
          informal: 'tipo de comercio',
        },
        modal: {
          title: 'Eliminar tipo de comercio',
        },
      },
      withdrawals: {
        plural: {
          formal: 'Retiros',
          informal: 'retiros',
        },
        singular: {
          formal: 'Retiro',
          informal: 'retiro',
        },
        manteca: {
          plural: {
            formal: 'Manteca',
            informal: 'manteca',
          },
          notAllowed: 'No tienes permisos para ver esta sección.',
          refresh: 'Actualizar',
          filters: {
            title: 'Filtros',
            status: 'Estado',
            from: 'Desde',
            to: 'Hasta',
            datePlaceholder: 'Selecciona una fecha',
            clear: 'Limpiar',
            search: 'Buscar',
          },
          create: {
            button: 'Solicitar retiro',
            title: 'Solicitar retiro Manteca',
            walletAddress: 'Dirección de billetera',
            network: 'Red',
            asset: 'Activo',
            amount: 'Monto',
            available: 'Disponible',
            balanceLoading: 'Consultando saldo disponible...',
            balanceZero: 'Sin saldo disponible para retirar.',
            balanceError:
              'No se pudo obtener el saldo en este momento. Intente nuevamente.',
            retry: 'Reintentar',
            amountPositive: 'Ingrese un monto mayor a 0.',
            amountExceedsAvailable: 'El monto no puede superar el saldo disponible.',
            disclaimer:
              'La dirección de billetera, red y activo están configurados por el servidor y no pueden modificarse. ' +
              'El monto a retirar no puede superar el saldo disponible del comercio.',
            submit: 'Confirmar',
            cancel: 'Cancelar',
            tenantRequired: 'Selecciona empresa, comercio y sucursal para solicitar el retiro.',
            notOnboarded: 'Este comercio no está habilitado para retiros Manteca.',
            unavailable: 'El servicio de retiros no está disponible en este momento. Intente nuevamente.',
            success: 'Retiro solicitado correctamente. Se encuentra pendiente de procesamiento.',
            error: 'No se pudo solicitar el retiro. Intente nuevamente.',
          },
          batch: {
            button: 'Liquidar todo',
            title: 'Liquidar todos los saldos',
            description:
              'Se solicitará el retiro del saldo total disponible de todos los comercios Manteca habilitados, hacia la dirección configurada.',
            network: 'Red',
            walletAddress: 'Dirección de billetera',
            asset: 'Activo',
            requestedBy: 'Solicitado por',
            disclaimer:
              'Esta acción mueve fondos reales de todos los comercios. La dirección de billetera, red y activo están configurados por el servidor y no pueden modificarse.',
            submit: 'Confirmar',
            cancel: 'Cancelar',
            processing:
              'Tu solicitud está siendo procesada. Una vez completada, verás los registros en la lista.',
            error: 'No se pudo solicitar la liquidación. Intente nuevamente.',
          },
          list: {
            company: 'Empresa',
            commerce: 'Comercio',
            branch: 'Sucursal',
          },
          detail: {
            title: 'Detalle de retiro',
            status: 'Estado',
            statusMessage: 'Mensaje de estado',
            company: 'Empresa',
            commerce: 'Comercio',
            branch: 'Sucursal',
            asset: 'Activo',
            amount: 'Monto',
            address: 'Dirección de billetera',
            network: 'Red',
            networkId: 'Hash de transacción',
            createdBy: 'Solicitado por',
            createdAt: 'Fecha de creación',
            updatedAt: 'Última actualización',
            externalId: 'ID externo',
          },
        },
      },
    },
    company: {
      commerce: {
        profile: {
          heading: {
            company: '@:menu.company.plural.formal',
          },
        },
      },
      documents: {
        help: {
          uploadLimit: 'Puede subir archivos de hasta 100 MB',
        },
      },
      header: {
        tabSelect: '@:menu.commerce.plural.formal',
        currentPage: '@:menu.company.singular.formal',
        navLink: '@:menu.company.plural.formal',
        newCompanyButton: 'Nueva @:menu.company.singular.formal',
      },
      table: {
        bussinessName: '@:menu.company.plural.formal',
        title: '@:menu.company.plural.formal',
        input: {
          search: 'Búsqueda por @:menu.company.singular.formal',
        },
        options: {
          add: 'Agregar @:menu.commerce.singular.formal',
        },
      },
      bankData: {
        paymentType: {
          formal: 'Tipo de pago',
          informal: 'tipo de pago',
        },
        blockchain: {
          formal: 'Blockchain',
          informal: 'blockchain',
          ethereumInvalidAddress: 'Por favor ingrese una dirección de Ethereum válida',
          tronInvalidAddress: 'Por favor ingrese una dirección de Tron válida',
        },
        walletAddress: {
          formal: 'Dirección de la billetera',
          informal: 'dirección de la billetera',
        },
        confirmWalletAddress: {
          formal: 'Confirmar @:company.bankData.walletAddress.informal',
          informal: 'confirmar @:company.bankData.walletAddress.informal',
        },
        legalDisclaimer: {
          formal: 'Aviso legal',
          informal: 'aviso legal',
          text: 'Declaro que la dirección de la billetera ingresada es correcta y reconozco que cualquier error puede resultar ' +
            'en la pérdida irreversible de fondos. Nemi Pay no será responsable por transacciones enviadas a direcciones ' +
            'incorrectas.',
        },

      },
    },
    commerce: {
      header: {
        tabSelect: '@:menu.commerce.plural.formal',
        currentPage: '@:menu.commerce.singular.formal',
        navLink: '@:menu.commerce.plural.formal',
        newCommerceButton: 'Nuevo @:menu.commerce.singular.formal',
      },
      table: {
        bussinessName: '@:menu.commerce.plural.formal',
        title: '@:menu.commerce.plural.formal',
        input: {
          search: 'Búsqueda por @:menu.commerce.singular.formal',
        },
      },
    },
    myProfile: {
      security: {
        singular: {
          formal: 'Seguridad',
          informal: 'seguridad',
        },
      },
    },
    commpixDetails: {
      bankAccountHolder: 'Titular',
      bankAccountType: 'Tipo de Cuenta',
      bankName: 'Banco',
      bankBranchNumber: 'Sucursal',
      bankAccountNumber: 'Número de Cuenta',
    },
    credentials: {
      commpix: {
        title: 'Credenciales CommPIX',
        helperText1: 'Para obtener las credenciales de CommPIX, contacta a tu representante de ventas.',
        helperText2: 'Asegúrate de que las credenciales sean válidas antes de guardar.',
      },
      masspayment: {
        title: 'Credenciales MassPayment',
        helperText1: 'Para obtener las credenciales de MassPayment, contacta a tu representante de ventas.',
        helperText2: 'Asegúrate de que las credenciales sean válidas antes de guardar.',
      },
    },
  },
};
